import { Validator } from '@vista-digital/validator';
/**
 * Default display labels for the Composite Filter component.
 */
export const defaultCompositeFilterDisplayText = {
    filterTitleLabel: 'Filter',
    genreFilterLabel: 'Genre',
    attributeFilterLabel: 'Experience',
    categoryFilterLabel: 'Category',
    eventFilterLabel: 'Event',
    billingPeriodFilterLabel: 'Billing period',
    billingRecurrenceFilterLabel: 'Billing type',
    subscriptionFilterLabel: 'Subscription',
    allFilterOptionLabel: undefined,
    modalTriggerButtonLabel: 'Filter by',
    accordionHeaderClearFiltersButtonLabel: 'Clear filters',
    modalCancelButtonLabel: 'Cancel',
    modalApplyButtonLabel: 'Apply',
    modalClearFiltersButtonLabel: 'Clear',
    selectFiltersMessage: 'Select filters to update results',
    resultCountMessage: '${count} film result(s) found'
};
export const compositeFilterDisplayTextValidator = Validator.object({
    filterTitleLabel: Validator.nonEmptyString,
    genreFilterLabel: Validator.nonEmptyString,
    attributeFilterLabel: Validator.nonEmptyString,
    categoryFilterLabel: Validator.nonEmptyString,
    eventFilterLabel: Validator.nonEmptyString,
    billingPeriodFilterLabel: Validator.nonEmptyString,
    billingRecurrenceFilterLabel: Validator.nonEmptyString,
    subscriptionFilterLabel: Validator.nonEmptyString,
    allFilterOptionLabel: Validator.optional(Validator.nonEmptyString),
    modalTriggerButtonLabel: Validator.nonEmptyString,
    accordionHeaderClearFiltersButtonLabel: Validator.nonEmptyString,
    modalCancelButtonLabel: Validator.nonEmptyString,
    modalApplyButtonLabel: Validator.nonEmptyString,
    modalClearFiltersButtonLabel: Validator.nonEmptyString,
    selectFiltersMessage: Validator.nonEmptyString,
    resultCountMessage: Validator.nonEmptyString
});
//# sourceMappingURL=display-text.js.map